import { render, staticRenderFns } from "./RatingKurir.vue?vue&type=template&id=e67e79c6"
import script from "./RatingKurir.vue?vue&type=script&lang=js"
export * from "./RatingKurir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports